var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mini-sensor",class:_vm.cssClass,attrs:{"data-counter":_vm.counter}},[_vm._t("default",function(){return [(_vm.icon)?_c('img',{staticClass:"image",attrs:{"src":_vm.icon,"draggable":"false"}}):_vm._e()]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }